var _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBannerImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1049 859",
    filter: "blur(20px)",
    preserveAspectRatio: "xMidYMid",
    width: 1049,
    height: 859,
    style: {
      shapeRendering: "auto",
      display: "block",
      background: "transparent"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      transform: "translate(524.5px,429.5px) scale(-1,1) translate(-524.5px,-429.5px)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(767.3006513535788,154.09672078517679) scale(100)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fill: "#FAA42A",
    d: "M3.5246399999999998 0 C3.5246399999999998 0.7342999999999998 3.6739467607943492 1.2732575460010866 3.3067967607943496 1.9091799999999999 S2.3982424539989133 2.6852777791947835 1.7623200000000003 3.0524277791947836 S0.7343000000000001 3.81836 2.3380711759961437e-16 3.81836 S-1.1263975460010858 3.4195777791947837 -1.762319999999999 3.052427779194784 S-2.9396467607943486 2.5451024539989144 -3.3067967607943487 1.9091800000000014 S-3.5246399999999998 0.7343000000000003 -3.5246399999999998 4.316439094146727e-16 S-3.6739467607943497 -1.2732575460010858 -3.30679676079435 -1.909179999999999 S-2.3982424539989147 -2.6852777791947826 -1.7623200000000014 -3.0524277791947827 S-0.7343000000000005 -3.81836 -7.014213527988431e-16 -3.81836 S1.126397546001084 -3.4195777791947846 1.7623199999999974 -3.052427779194785 S2.939646760794348 -2.545102453998915 3.3067967607943483 -1.9091800000000019 S3.5246399999999998 -0.7343000000000007 3.5246399999999998 -8.632878188293454e-16"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0;60",
    repeatCount: "indefinite",
    dur: "10s",
    type: "rotate",
    attributeName: "transform"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(815.8607816242945,99.0160649422121) scale(100)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fill: "#8E5122",
    d: "M4.229568 0 C4.229568 0.8811599999999998 4.408736112953219 1.5279090552013037 3.9681561129532192 2.2910159999999995 S2.8778909447986964 3.2223333350337406 2.1147840000000007 3.662913335033741 S0.8811600000000002 4.582032 2.8056854111953725e-16 4.582032 S-1.3516770552013035 4.103493335033741 -2.1147839999999993 3.6629133350337413 S-3.527576112953218 3.054122944798697 -3.9681561129532184 2.2910160000000013 S-4.229568 0.8811600000000004 -4.229568 5.179726912976073e-16 S-4.408736112953219 -1.5279090552013026 -3.9681561129532197 -2.2910159999999986 S-2.877890944798698 -3.2223333350337398 -2.114784000000002 -3.66291333503374 S-0.8811600000000007 -4.582032 -8.417056233586117e-16 -4.582032 S1.3516770552013013 -4.1034933350337415 2.1147839999999976 -3.6629133350337426 S3.5275761129532173 -3.0541229447986975 3.9681561129532175 -2.291016000000002 S4.229568 -0.8811600000000008 4.229568 -1.0359453825952146e-15"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0;60",
    repeatCount: "indefinite",
    dur: "5s",
    type: "rotate",
    attributeName: "transform"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(932.4050942740123,-33.17750908090295) scale(100)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fill: "#5FA3B2",
    d: "M5.921395199999999 0 C5.921395199999999 1.2336239999999996 6.172230558134506 2.139072677281825 5.555418558134506 3.207422399999999 S4.029047322718174 4.511266669047236 2.9606976 5.128078669047236 S1.233624 6.414844799999999 3.927959575673521e-16 6.414844799999999 S-1.892347877281824 5.744890669047236 -2.9606975999999983 5.128078669047237 S-4.938606558134504 4.275772122718175 -5.555418558134504 3.207422400000002 S-5.921395199999999 1.2336240000000003 -5.921395199999999 7.251617678166501e-16 S-6.1722305581345065 -2.1390726772818236 -5.555418558134507 -3.207422399999998 S-4.029047322718176 -4.5112666690472345 -2.9606976000000023 -5.128078669047235 S-1.2336240000000007 -6.414844799999999 -1.1783878727020563e-15 -6.414844799999999 S1.8923478772818212 -5.744890669047237 2.9606975999999956 -5.128078669047238 S4.938606558134504 -4.275772122718176 5.555418558134504 -3.2074224000000022 S5.921395199999999 -1.2336240000000012 5.921395199999999 -1.4503235356333001e-15"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0;60",
    repeatCount: "indefinite",
    dur: "3.3333333333333335s",
    type: "rotate",
    attributeName: "transform"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    transform: "translate(1177.1481508384195,-310.7840145294448) scale(100)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0,
    fill: "#FAA42A",
    d: "M9.474232319999999 0 C9.474232319999999 1.9737983999999993 9.87556889301521 3.42251628365092 8.88866969301521 5.131875839999998 S6.446475716349078 7.218026670475577 4.73711616 8.204925870475577 S1.9737984 10.263751679999999 6.284735321077634e-16 10.263751679999999 S-3.027756603650919 9.191825070475579 -4.737116159999998 8.204925870475579 S-7.901770493015208 6.841235396349081 -8.888669693015208 5.131875840000003 S-9.474232319999999 1.9737984000000004 -9.474232319999999 1.16025882850664e-15 S-9.875568893015211 -3.4225162836509178 -8.888669693015212 -5.131875839999997 S-6.446475716349082 -7.218026670475575 -4.737116160000004 -8.204925870475575 S-1.973798400000001 -10.263751679999999 -1.8854205963232898e-15 -10.263751679999999 S3.0277566036509143 -9.191825070475579 4.737116159999993 -8.20492587047558 S7.9017704930152055 -6.841235396349082 8.888669693015206 -5.131875840000004 S9.474232319999999 -1.9737984000000015 9.474232319999999 -2.32051765701328e-15"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    values: "0;60",
    repeatCount: "indefinite",
    dur: "2.5s",
    type: "rotate",
    attributeName: "transform"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBannerImage);
export default __webpack_public_path__ + "static/media/home-banner-image.f32e09a68bf52e84a93c7d3459befeed.svg";
export { ForwardRef as ReactComponent };